/* eslint-disable jsx-a11y/heading-has-content */
import React from "react";

function SectionDivider() {
    return (
        <div className="d-flex flex-nowrap justify-content-center align-items-center" id="section-divider">
            <h5 className="me-2"></h5>
                &#9733;
                &#9733;
                &#9733;
            <h5 className="ms-2"></h5>
        </div>
    )
}

export default SectionDivider